import { render } from "./KioskSettings.vue?vue&type=template&id=e84e50b2"
import script from "./KioskSettings.vue?vue&type=script&lang=js"
export * from "./KioskSettings.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__